export default __webpack_public_path__ + "static/media/apenko_17.f4b5c373.png";